import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router-dom';

const SchemeEnrollmentRoute: RouteObject = {
  path: 'scheme-enrollment',
  element: <Navigate to='/scheme-management' replace />,
};

export default SchemeEnrollmentRoute;
